import { Typography } from '@material-tailwind/react';

interface Props {
  summary?: string | null;
}

/** AI summary section of the content detail page. Renders nothing when empty. */
const ContentSummary = ({ summary }: Props) => {
  const text = typeof summary === 'string' ? summary.trim() : '';

  if (!text) {
    return null;
  }

  const title =
    localStorage.getItem('appLanguage') === 'en' ? 'Summary' : 'Resumen';

  return (
    <div className="mb-6">
      <Typography variant="h6">{title}</Typography>
      <Typography variant="paragraph" className="whitespace-pre-line">
        {text}
      </Typography>
    </div>
  );
};

export default ContentSummary;
